import React from 'react';
import {
  BrowserRouter as Router, Switch, Route,
} from 'react-router-dom';
import './App.css';
import PurCo from './components/purco/PurCo';
import MoblyxMsg from "./components/landing/MoblyxMsg";
import NewsLetter from "./components/purco/NewsLetter";

export default function App() {

  // take out chat widget
  // useEffect(() => {
  //   const BASE_URL = 'https://app.chatwoot.com';
  //   const g = document.createElement('script');
  //   const s = document.getElementsByTagName('script')[0];
  //   g.src = `${BASE_URL}/packs/js/sdk.js`;
  //   s.parentNode.insertBefore(g, s);
  //   g.onload = () => {
  //     window.chatwootSDK.run({
  //       websiteToken: 'nTMeAR5csuJzjaZvy6tAmuvt',
  //       baseUrl: BASE_URL,
  //     });
  //   };
  // }, []);

  return (
    <Router>
      <Switch>
        <Route path="/purco">
          <PurCo />
        </Route>
        <Route path="/news">
          <NewsLetter />
        </Route>
        <Route path="/">
          <MoblyxMsg />
        </Route>
      </Switch>
    </Router>
  );
}
